// extracted by mini-css-extract-plugin
export default {"transferPoint":"enFS5F","startPoint":"Xxsjin","endPoint":"uownP5","tooltip":"mOJFJ9","tooltipText":"CpvHHO"};